angular.module('impactx').factory('BackFactory', BackFactory);

function BackFactory() {
    var lotId = 0;
    var lotSupplierId = 0;

    this.getLotId = function () {
        return lotId;
    };

    this.setLotId = function (aLotId) {
        lotId = aLotId;
    };

    this.getLotSupplierId = function () {
        return lotSupplierId;
    };

    this.setLotSupplierId = function (aLotSupplierId) {
        lotSupplierId = aLotSupplierId;
    };

    return {
        setLotId: this.setLotId,
        getLotId: this.getLotId,
        getLotSupplierId: this.getLotSupplierId,
        setLotSupplierId: this.setLotSupplierId
    }
}